import {
  type DeviceFragment,
  DeviceGeneralStatus,
} from '@cobliteam/api-lib/src/__generated__/graphql';

const getDevicesStatusSummary = (devices: DeviceFragment[]) => {
  const initialSummary = {
    [DeviceGeneralStatus.Unavailable]: 0,
    [DeviceGeneralStatus.Disconnected]: 0,
    [DeviceGeneralStatus.NoSignal]: 0,
    [DeviceGeneralStatus.Syncing]: 0,
    [DeviceGeneralStatus.Normal]: 0,
    [DeviceGeneralStatus.NoSufficientData]: 0,
    [DeviceGeneralStatus.LosingData]: 0,
    [DeviceGeneralStatus.Damaged]: 0,
  };

  return devices.reduce((acc, device) => {
    const { generalStatus } = device;

    return {
      ...acc,
      [generalStatus]: acc[generalStatus] + 1,
    };
  }, initialSummary);
};

const sortByStatus = (
  statusA: DeviceGeneralStatus,
  statusB: DeviceGeneralStatus
) => {
  const statusPriority = {
    [DeviceGeneralStatus.Damaged]: 1,
    [DeviceGeneralStatus.Disconnected]: 2,
    [DeviceGeneralStatus.Unavailable]: 3,
    [DeviceGeneralStatus.Normal]: 4,
    [DeviceGeneralStatus.NoSignal]: 5,
    [DeviceGeneralStatus.NoSufficientData]: 6,
    [DeviceGeneralStatus.Syncing]: 7,
    [DeviceGeneralStatus.LosingData]: 8,
  };

  return statusPriority[statusA] - statusPriority[statusB];
};

export { getDevicesStatusSummary, sortByStatus };
